import { ContactPropsModel } from "@/components/Contact/Contact.model";
import { FooterPropsModel } from "@/components/Footer/Footer.model";
import { NavItem } from "@/components/GlobalNav/GlobalNav.model";
import { LogoTheme } from "@/components/Logo/Logo.model";

export interface ContentfulItems {
  sys?: {
    id?: string;
  };
  __typename?: string;
}

export interface ContentfulPageItems {
  title: string;
  slug: string;
  template: {
    logoTheme: LogoTheme;
    footer: FooterPropsModel;
    contact: ContactPropsModel;
  };
}

export interface ContentfulAsset {
  title?: string;
  description?: string;
  contentType?: string;
  fileName?: string;
  url: string;
  width?: number;
  height?: number;
}

export interface ImageFocalPoint {
  focalPoint: {
    x: number;
    y: number;
  };
}

export interface FocalImage extends ContentfulItems {
  image: ContentfulAsset;
  focalPoint: ImageFocalPoint;
}

export enum COLOR_PICKER {
  Black = "core-black",
  White = "core-white",
  Red = "core-red",
  "Slate Dark" = "core-slate-dark",
  "Slate Medium" = "core-slate-medium",
  "Slate Light" = "core-slate-light",
}

export interface ContentfulColor {
  id: string;
  name: COLOR_NAME;
  value: string;
}

export type COLOR_NAME = keyof typeof COLOR_PICKER;

export interface ContentfulMenu {
  componentMenuCollection: {
    items: {
      menuItemsCollection: {
        items: NavItem[];
      };
    }[];
  };
}

export type ALIGEMENT = "Left" | "Middle" | "Right";

export type TEXT_POSITION = "Top" | "Middle";
